(() => {
  'use strict';
  const configElement = document.getElementById('AparuOriginalsPolicy');
  if (!configElement) return;
  let config;
  try { config = JSON.parse(configElement.textContent); } catch { return; }
  const pausedIds = new Set(config.pausedVariantIds.map(String));
  const isPausedVariant = id => pausedIds.has(String(id || ''));
  const message = config.message;
  const announce = element => {
    const scope = element.closest?.('product-form, .card-wrapper, .pilot-card, .aparu-originals-unavailable') || element.parentElement || document.body;
    let notice = scope.querySelector('[data-originals-only-notice]');
    if (!notice) {
      notice = document.createElement('p');
      notice.dataset.originalsOnlyNotice = '';
      notice.setAttribute('role', 'status');
      scope.append(notice);
    }
    notice.textContent = message;
  };
  const pausedURL = href => {
    let url;
    try { url = new URL(href, location.href); } catch { return false; }
    if (url.origin !== location.origin) return false;
    return isPausedVariant(url.searchParams.get('variant')) || config.pausedPaths.some(path => url.pathname === path || url.pathname.endsWith(path));
  };
  window.AparuOriginalsOnly = Object.freeze({ isPausedVariant, message, announce, pausedURL });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.action.includes('/cart/add') && isPausedVariant(new FormData(form).get('id'))) {
      event.preventDefault();
      event.stopImmediatePropagation();
      announce(form);
    }
    if (event.submitter?.name === 'checkout' && document.querySelector('[data-originals-cart-paused]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      announce(form);
    }
  }, true);
  document.addEventListener('click', event => {
    const target = event.target.closest?.('add-to-cart[data-variant-id], a[href]');
    if (!target) return;
    if (target.matches('add-to-cart') && isPausedVariant(target.dataset.variantId)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      announce(target);
    } else if (target.matches('a[href]') && pausedURL(target.href)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  const update = () => {
    document.querySelectorAll('a[href]').forEach(link => {
      if (pausedURL(link.href)) {
        const item = link.closest('li');
        if (item && item.querySelectorAll('a[href]').length === 1) { item.hidden = true; item.style.setProperty('display', 'none', 'important'); }
        else { link.hidden = true; link.style.setProperty('display', 'none', 'important'); }
        link.removeAttribute('href');
        link.setAttribute('aria-hidden', 'true');
      }
    });
    if (document.querySelector('[data-originals-cart-paused]')) {
      document.querySelectorAll('[name="checkout"], a[href="/checkout"]').forEach(button => {
        if (button instanceof HTMLButtonElement || button instanceof HTMLInputElement) button.disabled = true;
        else { button.removeAttribute('href'); button.setAttribute('aria-disabled', 'true'); }
      });
    }
  };
  update();
  let pending = false;
  new MutationObserver(() => {
    if (pending) return;
    pending = true;
    queueMicrotask(() => { pending = false; update(); });
  }).observe(document.body, { childList: true, subtree: true });
  const fallback = document.querySelector('[data-originals-only-replace-url]')?.dataset.originalsOnlyReplaceUrl;
  // The fallback exists only when the selected variant is paused and an original remains.
  if (location.pathname.includes('/products/') && fallback) location.replace(fallback);
})();
